// @flow
import React, { Component } from 'react';
import RecentPostCards from 'containers/list/RecentPostCards';
import RecentTemplate from 'components/recent/RecentTemplate/RecentTemplate';
import ScrollToTop from 'components/common/ScrollToTop';
import { Helmet } from 'react-helmet';
import type { ContextRouter } from 'react-router-dom';
import queryString from 'query-string';

type Props = {} & ContextRouter;

class Recent extends Component<Props> {
  render() {
    const { location, match, history } = this.props;
    const { sort } = queryString.parse(location.search);
    const { category } = match.params;
    return (
      <RecentTemplate>
        <Helmet>
          <title>블로그 | 캐시바이</title>
          <meta
            name="description"
            content="캐시바이에 방금 등록된 다양한 바이오 소식 포스트를 살펴보세요."
          />
        </Helmet>
        <RecentPostCards category={category} sort={sort} />
      </RecentTemplate>
    );
  }
}

export default Recent;



// WEBPACK FOOTER //
// ./src/pages/Recent.js